import { useEffect, useState } from 'react';
import { SubText as SubTextType } from '@topdanmark-onlinesolutions/claim-form-types';
import { ModalOverlay, ModalDialog, ModalHeader, ModalBody, Button, ModalFooter } from '@flos/react-ui';

export const SubText = ({ SubTextList }: { SubTextList: SubTextType[] }) => {
    const [modalStates, setModalStates] = useState<boolean[]>(SubTextList.map(() => false));
    const toggleModal = (index: number) => {
        setModalStates((prevStates) => {
            const newStates = [...prevStates];
            newStates[index] = !newStates[index];
            return newStates;
        });
    };
    useEffect(() => {
        const createEvents = (mount: boolean) => {
            SubTextList.forEach((_, index) => {
                const items = SubTextList[index];
                if (items.type === 'modal') {
                    const elementId = items.custom.activationId;
                    const element = document.getElementById(elementId);
                    if (element) {
                        if (mount) {
                            element.addEventListener('click', () => toggleModal(index));
                        } else {
                            element.removeEventListener('click', () => toggleModal(index));
                        }
                    }
                }
            });
        };
        createEvents(true);

        return () => {
            createEvents(false);
        };
    }, [SubTextList]);

    return (
        <>
            {SubTextList.map((item, index) => {
                switch (item.type) {
                    case 'text':
                        return (
                            <div className="page-subtext" key={`subtext-${index}`}>
                                {item.value}
                                <br />
                            </div>
                        );
                    case 'html':
                        return (
                            <div className="page-subtext" key={`subtext-${index}`}>
                                <div dangerouslySetInnerHTML={{ __html: item.value }} />
                                <br />
                            </div>
                        );
                    case 'modal':
                        return (
                            <div className="page-subtext" key={`subtext-${index}`}>
                                <ModalOverlay
                                    isOpen={modalStates[index]}
                                    onDismiss={() => toggleModal(index)}
                                    key={index}
                                >
                                    <ModalDialog closeIconHandler={() => toggleModal(index)}>
                                        <ModalHeader></ModalHeader>
                                        <ModalBody>
                                            <div dangerouslySetInnerHTML={{ __html: item.value }} />
                                        </ModalBody>

                                        <ModalFooter>
                                            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                <Button theme="primary" onClick={() => toggleModal(index)}>
                                                    Luk
                                                </Button>
                                            </div>
                                        </ModalFooter>
                                    </ModalDialog>
                                </ModalOverlay>
                            </div>
                        );
                    default:
                        return <></>;
                }
            })}
        </>
    );
};
